module.exports = __webpack_public_path__ + "img/2HowToUse.abe7b555.png";